import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const _get = async (queryParamFilters, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/reason',
    params: params,
  })

  return response?.data
}

export const get = (queryParamFilters) => async (queryParam) =>
  await _get(queryParamFilters, queryParam)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/reason/${id}`,
  })

  return response?.data
}

export const storeRescheduleType = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/reason',
    data: {
      ...data,
      type: 'RESCHEDULED',
    },
  })

  return response?.data
}

export const storeCancelType = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/reason',
    data: {
      ...data,
      type: 'CANCELED',
    },
  })

  return response?.data
}

export const storeTransferType = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/reason',
    data: {
      ...data,
      type: 'TRANSFERRED',
    },
  })

  return response?.data
}

export const updateRescheduleType = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/reason/${id}`,
    data: {
      ...data,
      type: 'RESCHEDULED',
    },
  })

  return response?.data
}

export const updateCancelType = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/reason/${id}`,
    data: {
      ...data,
      type: 'CANCELED',
    },
  })

  return response?.data
}

export const updateTransferType = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/reason/${id}`,
    data: {
      ...data,
      type: 'TRANSFERRED',
    },
  })

  return response?.data
}

export const deleteSingle = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/reason/${id}`,
  })

  return response?.data
}
